import React from "react";
import { CircularProgress } from "@mui/material";

/**
 * 画面を覆うローディングアイコンコンポーネント
 * @param {boolean} open 読み込み中フラグ
 * @class OverlayLoading
 */
export default function OverlayLoading({ open }) {
  return (
    <>
      {open && (
        <div className="overlay-container">
          <CircularProgress />
        </div>
      )}
    </>
  );
}
